import React, { useState } from 'react'
    import { Link, useLocation } from 'react-router-dom'
    import { Menu, X, Sparkles } from 'lucide-react'

    const Navbar = () => {
      const [isOpen, setIsOpen] = useState(false)
      const location = useLocation()

      const navigation = [
        { name: 'Home', href: '/' },
        { name: 'About', href: '/about' },
        { name: 'Contact', href: '/contact' },
      ]

      const isActive = (path) => location.pathname === path

      return (
        <nav className="bg-white shadow-lg sticky top-0 z-50" data-component-path="client/src/components/Navbar.jsx" data-component-line="1:4" data-component-id="client/src/components/Navbar.jsx:1:4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="2:6" data-component-id="client/src/components/Navbar.jsx:2:6">
            <div className="flex justify-between h-16" data-component-path="client/src/components/Navbar.jsx" data-component-line="3:8" data-component-id="client/src/components/Navbar.jsx:3:8">
              <div className="flex items-center" data-component-path="client/src/components/Navbar.jsx" data-component-line="4:10" data-component-id="client/src/components/Navbar.jsx:4:10">
                <Link to="/" className="flex items-center space-x-2" data-component-path="client/src/components/Navbar.jsx" data-component-line="5:12" data-component-id="client/src/components/Navbar.jsx:5:12">
                  <Sparkles className="h-8 w-8 text-blue-600" data-component-path="client/src/components/Navbar.jsx" data-component-line="6:14" data-component-id="client/src/components/Navbar.jsx:6:14" />
                  <span className="text-xl font-bold text-gray-900" data-component-path="client/src/components/Navbar.jsx" data-component-line="7:14" data-component-id="client/src/components/Navbar.jsx:7:14">ModernApp</span>
                </Link>
              </div>

              {/* Desktop Navigation */}
              <div className="hidden md:flex items-center space-x-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="8:10" data-component-id="client/src/components/Navbar.jsx:8:10">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                      isActive(item.href)
                        ? 'text-blue-600 bg-blue-50'
                        : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                    }`}
                    data-component-path="client/src/components/Navbar.jsx" data-component-line="9:12" data-component-id="client/src/components/Navbar.jsx:9:12"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>

              {/* Mobile menu button */}
              <div className="md:hidden flex items-center" data-component-path="client/src/components/Navbar.jsx" data-component-line="10:10" data-component-id="client/src/components/Navbar.jsx:10:10">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="text-gray-700 hover:text-blue-600 focus:outline-none focus:text-blue-600"
                  data-component-path="client/src/components/Navbar.jsx" data-component-line="11:12" data-component-id="client/src/components/Navbar.jsx:11:12"
                >
                  {isOpen ? <X className="h-6 w-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="12:14" data-component-id="client/src/components/Navbar.jsx:12:14" /> : <Menu className="h-6 w-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="13:14" data-component-id="client/src/components/Navbar.jsx:13:14" />}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="md:hidden bg-white border-t border-gray-200" data-component-path="client/src/components/Navbar.jsx" data-component-line="14:8" data-component-id="client/src/components/Navbar.jsx:14:8">
              <div className="px-2 pt-2 pb-3 space-y-1" data-component-path="client/src/components/Navbar.jsx" data-component-line="15:10" data-component-id="client/src/components/Navbar.jsx:15:10">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
                      isActive(item.href)
                        ? 'text-blue-600 bg-blue-50'
                        : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                    }`}
                    onClick={() => setIsOpen(false)}
                    data-component-path="client/src/components/Navbar.jsx" data-component-line="16:12" data-component-id="client/src/components/Navbar.jsx:16:12"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </nav>
      )
    }

    export default Navbar